export default __webpack_public_path__ + "static/media/OnisQuest_BETA-min.f046fc35.png";